import React, { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import { Assessment } from "../../../interfaces/AssessmentInterfaces";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface Other1Props {
  assessment: Partial<Assessment>;
  onChange: (value: string) => void;
}

const MAX_LENGTH = 2000;

// eslint-disable-next-line import/prefer-default-export
export const Other1: React.FC<Other1Props> = ({ assessment, onChange }) => {
  const assessmentLabels = useAssessmentLabel();

  const [value, setValue] = useState(assessment.other1 || "");

  const isError = value.length > MAX_LENGTH;

  useEffect(() => {
    setValue(assessment.other1 || "");
  }, [assessment.other1]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel} sx={{ display: "flex", alignItems: "center" }}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.other1 || "Other1"}
        </Typography>
      </Box>

      <Box className={styles.assessmentField}>
        <TextField
          fullWidth
          label={assessmentLabels.other1 || "Other1"}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: {
              maxLength: MAX_LENGTH
            },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          placeholder="Enter other observations"
          variant="outlined"
          margin="dense"
          multiline
          maxRows={4}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          error={isError}
          helperText={`${value.length}/${MAX_LENGTH}`}
          onFocus={(e) => e.target.select()}
        />
      </Box>
    </Box>
  );
};
